jQuery('.services-we-offer-images-container').slick({
    dots: true,
    infinite: true,
    slidesToShow: 5, // Default to 5 images per row on desktop
    arrows: true,
    autoplay: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4, // 4 images per row on medium screens
                arrows: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2, // 2 images per row on mobile
                arrows: true
            }
        }
    ]
  });